import CoreuiController from "../lib/coreui-controller"
import Toast from "../coreui/toast"

export default class CoreuiToastController extends CoreuiController {
  static Component = Toast
}
